import { render, staticRenderFns } from "./greenCardInfo.vue?vue&type=template&id=002448b2&scoped=true&"
import script from "./greenCardInfo.vue?vue&type=script&lang=js&"
export * from "./greenCardInfo.vue?vue&type=script&lang=js&"
import style0 from "./greenCardInfo.vue?vue&type=style&index=0&id=002448b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002448b2",
  null
  
)

export default component.exports